import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";


@Injectable({
  providedIn: "root",
})
export class BdspStaticService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getStaticData(
    type: string,
    start_element: number = 0,
    num_elements: number = 300,
    params = {}
  ) {
    params["start_element"] = start_element;
    params["num_elements"] = num_elements;
    let url = this.buildUrl(`${this.BASE_BDSP_URL}/${type}/`, "", params);
    return this.get(url);
  }
}
